import apiUrl from '../../../constants';
import axios from 'axios';
//import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import download from 'downloadjs';
import Pagination from './../shared/pagination'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import JsonExcel from "vue-json-excel";
import Vue from "vue";
import JSZip from "jszip";
import csvHelper from '../reports/importjsontocsv';
Vue.component("downloadExcel", JsonExcel);


export default {
    name: 'merchant',
    components: {
        BasicSelect,
        Pagination,
        Loader,
        DatePicker,
        JsonExcel,
        download,
    },
    data: function () {
        return {

            formattedDate: '',
            currentPage: 1,
            totalPage: 0,
            totalCount: 0,
            pageLimit: 10,
            showSelectWarehouse: false,
            isLoading: false,
            showSelectClient: false,
            searchFlag: false,
            selecteddata: [],
            processstatus: '',
            checkstatus: '',
            listWarehouseData: [],
            listClientData: [],
            RejectlistSRRTO: [],
            fromdate: '',
            todate: '',
            warehouse: '',
            rto_srid: '',
            Merchant: '',
            WarehouseErr: '',
            MerchantErr: '',
            warehouseid: '',
            user_type: '',
            client: '',
            racktype: '',
            clientid: '',
            ClientErr: '',
            lineno: '',
            rackno: '',
            sectionid: '',
            RejectlistDataCsv: '',
            Reporttype: '',
            processname: '',
            processstatusarr: ['RVP', 'RTO'],
            userid: '',
            rackuti: '',
            rtoid: '',
            listReportDataforxls: [],
            csvFieldsForXls: {},
            reportname: '',
            show: '',
            limitExeed: '',
            download: true,
            listshippingcompanyData: [],
            couriername: '',
            awbno: '',
            stocktype: '',
            stocktypeErr: '',
            Image1: '',
            img1: '',
            img2: '',
            img3: '',
            labeling: '',
            errormsg: false,
            getDetails: false
        }
    },
    filters: {
        moment: function (date) {
            if (date)
                return moment(date).format('DD-MM-YYYY HH:mm:ss');
            else {
                return '';
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },

    mounted() {
        var today = new Date();
        this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.useremail = userdetail.email;
        var loginuseremail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        //  this.warehouse = userdetail.warehouseid;
        this.clientid = userdetail.clientid;
        this.loginClientUserId = userdetail.clientid;
        this.loginuserid = userdetail.userid;
        this.userid = userdetail.userid;
        this.user_type = userdetail.utype;
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        this.reportname = this.$t('editedjson.rejectlistSRRTO')
        this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';

        switch (this.user_type) {
            case 'system_user':

                this.showSelectWarehouse = true;
                this.showSelectClient = true;
                this.showSelectMerchant = true;
                // this.getWarehouseList();
                // this.getClientList();
                break;

            case 'warehouse_user':
                this.loginUserEmail = userdetail.email;
                this.warehouse = userdetail.warehouseid;
                this.warehouseid = userdetail.warehouseid;
                this.showSelectClient = true;
                this.showSelectMerchant = true;
                // this.getClientList();
                break;

            default:
                this.$alertify.error("Unauthorised user, Please contact your system admin");
                break
        }
    },
    methods: {
        filters: {
            moment: function (date) {
                if (!date) return '';
                return moment(date).format('DD-MM-YY hh:mm:ss');
            }
        },

        jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = []) {

            var csvData = '';
            //Header
            if (this.title != null) {
                csvData += this.parseExtraData(this.title, '${data}\r\n')
            }
            csvData += ''
            Object.entries(dataFilter).forEach(([k, v]) => {
                csvData += k + ':' + v + ','
            })
            csvData += '\r\n'
            csvData += '\r\n'
            //Fields
            for (let key in data[0]) {
                if (skipFilter.indexOf(key) == -1)
                    csvData += csvfield[key] + ',';
            }
            csvData = csvData.slice(0, csvData.length - 1);
            csvData += '\r\n';
            //Data
            data.map(function (item) {
                for (let key in item) {
                    if (skipFilter.indexOf(key) == -1) {
                        var escapedCSV = item[key] + ''; // cast Numbers to string
                        if (escapedCSV.match(/[,"\n]/)) {
                            escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
                        }
                        if (escapedCSV == 'null')
                            csvData += ',';
                        else {
                            if (dateFilter.indexOf(key) != -1)
                                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
                            else
                                csvData += escapedCSV + ',';
                        }
                    }
                }
                csvData = csvData.slice(0, csvData.length - 1);
                csvData += '\r\n';
            })
            //Footer
            if (this.footer != null) {
                csvData += this.parseExtraData(this.footer, '${data}\r\n');
            }
            filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
            return this.export(csvData, filename, "application/csv");
            return csvData;
        },

        export(data, filename, mime) {
            let blob = this.base64ToBlob(data, mime);
            download(blob, filename, mime);
        },

        base64ToBlob(data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
            let bstr = atob(base64);
            let n = bstr.length;
            let u8arr = new Uint8ClampedArray(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            })
        },
        closeDetails() {
            this.getDetails = false
            this.selecteddata = []
        },
        checkinput() {
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.pageno = 0;
            if (this.showSelectWarehouse == true) {
                this.warehouseid = this.warehousename
            }
            this.input = ({
                awbno: this.awbno,
                warehouse: localStorage.getItem("selectedWarehouse"),
                couriername: this.couriername
            });
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'checknopawbno',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    if (result.data.errorCode == -1) {
                        this.errormsg = true;
                        this.msg = result.data.msg;
                    } else {
                        this.errormsg = false;
                    }
                }, error => {
                    console.error(error);
                });
        },
        // getClientList() {
        //     if (window.localStorage.getItem("clientList") !== null) {
        //         var clientListEncrypt = window.localStorage.getItem('clientList');
        //         var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        //         var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        //         this.listClientData = JSON.parse(plaintextclient);
        //     }
        //     else {
        //         var userToken = window.localStorage.getItem('userToken');
        //         var myStr = userToken.replace(/"/g, '');
        //         this.pageno = this.totalPage = 0;

        //         if (this.warehouseid)
        //             this.input = ({
        //                 warehouseid: this.warehouseid,
        //             });
        //         else {
        //             this.input = {};
        //         }
        //         axios({
        //             method: 'POST',
        //             'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
        //             'data': this.input,
        //             headers: {
        //                 'Authorization': 'Bearer ' + myStr,
        //             }
        //         })
        //             .then(result => {
        //                 this.listClientData = result.data.data;

        //             }, error => {
        //                 console.error(error);
        //             });
        //     }
        // },


        // getWarehouseList() {
        //     var userToken = window.localStorage.getItem('userToken')
        //     var myStr = userToken.replace(/"/g, '');
        //     this.pageno = 0;
        //     this.input = ({
        //         'clientid': this.client,
        //     });
        //     axios({
        //         method: 'POST',
        //         'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
        //         'data': this.input,
        //         headers: {
        //             'Authorization': 'Bearer ' + myStr
        //         }
        //     })
        //         .then(result => {
        //             this.listWarehouseData = result.data.data;
        //         }, error => {
        //             console.error(error)
        //         })
        // },
        // clientSelected() {
        //     if (this.clientid != this.client || this.clientid == this.client) {
        //         this.clientid = this.client;
        //         if (this.user_type != 'warehouse_user') {
        //             this.listWarehouseData = []
        //             this.getWarehouseList();

        //             if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
        //                 this.warehouse = this.warehouseid = '';
        //             } else {
        //                 this.warehouse = ''
        //             }
        //         }
        //     }
        //     this.listRackinData = [];
        //     this.pageno = this.totalPage = 0;
        //     this.rackuti = ''
        // },

        // warehouseSelected() {
        //     this.warehouseid = this.warehouse;
        //     this.pageno = this.totalPage = 0;
        // },
        getdetails(data) {
            this.selecteddata = []
            this.getDetails = true;
            this.selecteddata.push(data);
        },

        downloadImage(imagedata) {

            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.pageno = 0;
            if (imagedata == null || imagedata == '' || imagedata == undefined) {
                this.$alertify.error("Image Not Found");
                return false;
            }
            this.isLoading = true
            this.input = ({
                's3url': imagedata,
            });
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'viewImagebyurl',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            }).then((result) => {

                if (result.data.Status) {
                    window.open(result.data.url)
                }
                else {
                    this.$alertify.error("Image Not Found");
                }
                this.isLoading = false
            })
        },

        downloadImageAsZip(data) {

            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            let flg = ''
            if (this.processstatus == 'RTO') {
                flg = data.rtoid
                this.input = ({
                    rto_rvp: "rto",
                    id: data.id,
                    clientid: this.client,
                    nopornot: 0

                });
            } else {
                flg = data.srid
                this.input = ({
                    rto_rvp: "rvp",
                    id: data.id,
                    clientid: this.client,
                    nopornot: 0
                });
            }
            this.isLoading = true
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'downloadimgzip',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            }).then((result) => {


                if (result.data.status == false)
                this.$alertify.error(result.data.msg)
                else {
                function _arrayBufferToBase64(buffer) {
                    var binary = '';
                    var bytes = new Uint8Array(buffer);
                    var len = bytes.byteLength;
                    for (var i = 0; i < len; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    return window.btoa(binary);
                }
                var zip = new JSZip();
                var img = new Image();
                var img = zip.folder("images");


                result.data.data.forEach((e, i) => {
                    let base64String = _arrayBufferToBase64(e.data)
                    if(result.data.extension[i]=='')
                    {result.data.extension[i]='.png'}
                    img.file(data.orderid+ '_' + (i+1) +'.'+ result.data.extension[i], base64String, { base64: true });

                })

                var saveAs = require('file-saver');

                let name= this.processstatus + '_' + flg + '_' + data.eancode + ".zip"
                zip.generateAsync({ type: "blob" }).then(function (content) {
                    saveAs(content, name);
                });
                this.isLoading = false
            }
            })


        },
        startDownload() {
            this.isLoadingforxls = true;
        },
        finishDownload() {
            this.isLoadingforxls = false;
        },
        Choosetype() {
            this.show = true;
            this.download = false;
            if (!this.limitExeed) {
                this.getRejectListForXLS(3)
            }
        },
        getRejectListForXLS(csvCheck = 0) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            var dataFilter = {};
            this.show = true;
            this.download = false;
            this.dataFilter2 = [];
            var value = '';
            var str = '';
            var fr_date = '';
            var to_date = ''
            if (this.fromdate) {
                fr_date = this.dateFormat(this.fromdate)
            }
            if (this.todate) {
                to_date = this.dateFormat(this.todate)
            }

            this.input = ({
                clientid: this.client,
                warehouseid: localStorage.getItem("selectedWarehouse"),
                awbno: this.awbno,
                processname: this.processstatus,
                processid: this.rto_srid,
                limit: this.pageLimit,
                fromdate: fr_date,
                todate: to_date,
                offset: (this.currentPage - 1) * 10,
            });
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    value += k + ':' + v + ','
                    this.dataFilter2 = str.concat(value);

                }
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getRejectProductsList',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    if (csvCheck == 3) {
                        if (result.data.count > 0) {

                            this.listReportDataforxls = [];
                            if (result.data.processname == 'RVP') {
                                this.csvFieldsForXls[this.$t('common.id')] = 'id';
                                this.csvFieldsForXls[this.$t('rejectlistrto.rvpID')] = 'srid';
                                this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
                                this.csvFieldsForXls[this.$t('common.productName')] = 'productname';
                                this.csvFieldsForXls[this.$t('editedjson.rejectReason')] = 'rejectreason';
                                this.csvFieldsForXls[this.$t('common.awbNo')] = 'awbno';
                                this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid';
                                this.csvFieldsForXls[this.$t('editedjson.imagesLink')] = 'imageslink';
                            } else if (result.data.processname == 'RTO') {
                                this.csvFieldsForXls[this.$t('common.id')] = 'id';
                                this.csvFieldsForXls[this.$t('shipment.rtoId')] = 'rtoid';
                                this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
                                this.csvFieldsForXls[this.$t('common.productName')] = 'productname';
                                this.csvFieldsForXls[this.$t('editedjson.rejectReason')] = 'rejectreason';
                                this.csvFieldsForXls[this.$t('common.awbNo')] = 'awbno';
                                this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid';
                                this.csvFieldsForXls[this.$t('editedjson.imagesLink')] = 'imageslink';
                            }

                            this.listReportDataforxls = result.data.data;
                        } else {
                            if (result.data.status == true) {
                                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
                            } else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }
                    }

                }, error => {
                    console.error(error);
                })
        },


        dateFormat(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD');
        },
        dateFormatFRT(date) {
            if (!date) return '';
            return moment(date).format('DD-MM-YY HH:mm:ss');
        },

        getRejectlistReportData(csvCheck = 0) {
            if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.isLoading = true;
            var fr_date = '';
            var to_date = '';

            if (this.fromdate) {
                fr_date = this.dateFormat(this.fromdate)
            }
            if (this.todate) {
                to_date = this.dateFormat(this.todate)
            }
            var dataFilter = {};

            if (csvCheck == 2) {
                this.show = false;
                this.download = true;
                this.currentPage = 1;
            }
            this.input = ({
                clientid: this.client,
                warehouseid: localStorage.getItem("selectedWarehouse"),
                awbno: this.awbno,
                processname: this.processstatus,
                processid: this.rto_srid,
                limit: this.pageLimit,
                fromdate: fr_date,
                todate: to_date,
                offset: (this.currentPage - 1) * 10,
            });
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    dataFilter[k] = v;
                }
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getRejectProductsList',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    this.Reporttype = result.data.processname
                    this.searchFlag = true;
                    if (csvCheck == 1) {
                        if (result.data.count > 0) {
                            this.RejectlistDataCsv = [];
                            this.csvFields = {
                                'id': this.$t('common.id'),
                                'rtoid': this.$t('shipment.rtoId'),
                                'srid': this.$t('rejectlistrto.rvpID'),
                                'eancode': this.$t('common.eanCode'),
                                'awbno': this.$t('common.awbNo'),
                                'labelimage': this.$t('rejectlistrto.labelImage'),
                                'orderid': this.$t('common.orderID'),
                                'productname': this.$t('common.productName'),
                                'producttype': this.$t('common.productType'),
                                'rejectreason': this.$t('editedjson.rejectReason'),
                                'imageslink': this.$t('editedjson.imagesLink')
                            };
                            var dateFilter = ['createddatetime'];
                            if (this.processname == 'RTO') {
                                var skipFilter = [];
                            } else if (this.processname == 'RVP') {
                                var skipFilter = [];
                            }
                            this.RejectlistDataCsv = result.data.data.filter(function (el) { return delete el.image1, delete el.image2, delete el.image3, delete el.productimage, delete el.labelimage });
                            csvHelper.data.jsonToCSV(this.$t('editedjson.rejectlistSRRTO'), this.RejectlistDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
                        }
                        else {

                            if (result.data.status == true) {
                                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
                            }
                            else if (result.data.data.length == true) {
                                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
                            }
                            else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }
                    } else {
                        if (result.data) {
                            this.RejectlistSRRTO = result.data.data;
                            this.totalCount = result.data.count
                            this.resultCount = result.data.count;
                            if (this.totalCount < 10) {
                                this.totalPage = 1
                            } else {
                                this.totalPage = Math.ceil(this.totalCount / 10);
                            }
                        }
                        else {
                            this.isLoading = false;
                            this.RejectlistSRRTO = []
                        }


                    }
                    this.isLoading = false;
                },
                    error => {
                        console.error(error);
                    })
        },

        onPageChange(page) {
            this.currentPage = page;
            this.getRejectlistReportData()
        },

        //Reset the Search filter
        resetForm() {
            this.totalCount = 0;
            this.processstatus = '',
                this.awbno = '',
                this.couriername = '',
                this.rto_srid = '',
                this.fromdate = '',
                this.todate = '',
                this.searchFlag = false
            this.errormsg = ''
            this.RejectlistSRRTO = [];
            this.$validator.reset();
            if (this.user_type == 'warehouse_user')
                this.clientaa = '';
            else if (this.user_type == 'client_user')
                this.warehouse = '';
            else {
                this.clientaa = '';
                this.warehouse = '';
            }
            this.getWarehouseList();
        },
        async validatevalues() {
            try {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.getRejectlistReportData(2);
                    } else {
                        console.log("not valid")
                    }
                })
            }
            catch (err) {
                this.isLoading = false;
                this.$alert(err, "", "error");
                console.log(err);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/RejectlistSRRTO/RejectlistSRRTO.component.js